import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box, Grid, IconButton } from "@mui/material";
import { backgroundColor } from "../../assets/styles/colors";
import Dialog from "@mui/material/Dialog";
import Slide from '@mui/material/Slide';
import { textFieldStyle } from "../../assets/styles/styles";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { WwwSearchPostComboBox } from "../entities/posts/post/WwwSearchPostComboBox";
import { CategoryFilterComboBox } from "../entities/posts/post/CategoryFilterComboBox";
import { globalAppConfigStore } from "../../stores/appConfig/globalAppConfigStore";
import { WwwSearchProductComboBox } from "../entities/products/product/WwwSearchProductComboBox";
import { searchAndFilterDialogStore } from "../../stores/searchAndFilterDialogStore";
const Transition = forwardRef((props, ref) => _jsx(Slide, { direction: "left", ref: ref, ...props }, void 0));
export const SearchAndFilterDialog = () => {
    const open = searchAndFilterDialogStore.useOpen();
    const config = globalAppConfigStore.useComponent('search-background');
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
@keyframes SearchAndFilter-fading {
  0%   { background: #00000000; }
  10%  { background: #00000000; }
  40%  { background: #000000cf; }
  60%  { background: #000000cf; }
  90%  { background: #00000000; }
  100% { background: #00000000; }
}
        ` }, void 0), _jsx(Dialog, { onClose: searchAndFilterDialogStore.close, open: open, fullScreen: true, TransitionComponent: Transition, keepMounted: true, "aria-describedby": "contact-us", 
                // onClick={sendContactInfoStore.closeContact}
                PaperProps: { sx: {
                        backgroundColor,
                        background: (config?.params?.background || "").replace("$url", config?.url || ""),
                        backgroundSize: 'cover',
                    } }, children: _jsx(Box, { sx: {
                        width: '100%',
                        background: 'transparent',
                        animation: 'SearchAndFilter-fading 30s infinite',
                    }, children: _jsx(Grid, { container: true, justifyContent: 'center', sx: {
                            width: '100%',
                            minHeight: '100vh',
                        }, children: _jsxs(Box, { sx: {
                                width: '100%',
                                maxWidth: '700px',
                                paddingTop: 8,
                                paddingBottom: 10,
                                paddingLeft: 2,
                                paddingRight: 2,
                            }, children: [_jsx(IconButton, { color: "error", size: 'large', sx: { position: 'absolute', top: 2, right: 2, ...textFieldStyle }, onClick: searchAndFilterDialogStore.close, children: _jsx(HighlightOffIcon, { sx: { width: 40, height: 40 } }, void 0) }, void 0), _jsx(Box, { sx: { paddingTop: 0, paddingBottom: 2 }, children: _jsx(CategoryFilterComboBox, { sx: { width: '100%' } }, void 0) }, void 0), _jsx(Box, { sx: { paddingTop: 0, paddingBottom: 2 }, children: _jsx(WwwSearchPostComboBox, { sx: { width: '100%' } }, void 0) }, void 0), _jsx(Box, { sx: { paddingTop: 0, paddingBottom: 2 }, children: _jsx(WwwSearchProductComboBox, { sx: { width: '100%' } }, void 0) }, void 0)] }, void 0) }, void 0) }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=SearchAndFilter.js.map